import { ArrowUpRight } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { useSite } from "@/site/SiteContext";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { SERVICE_IMAGES } from "@/data/works";
import { scrollToSection } from "@/lib/scroll";

const SERVICES = [
  { id: "corniches", img: SERVICE_IMAGES.corniches },
  { id: "rosaces", img: SERVICE_IMAGES.rosaces },
  { id: "colonnes", img: SERVICE_IMAGES.colonnes },
  { id: "moulures", img: SERVICE_IMAGES.moulures },
  { id: "panneaux", img: SERVICE_IMAGES.panneaux },
  { id: "decor", img: SERVICE_IMAGES.decor },
  { id: "restauration", img: SERVICE_IMAGES.restauration },
];

const Services = () => {
  const { t, lang } = useLang();
  const site = useSite();
  const ov = (site.services && site.services[lang]) || {};
  const sTitle = (id) => ov[id]?.title || t(`services.items.${id}.title`);
  const sDesc = (id) => ov[id]?.desc || t(`services.items.${id}.desc`);
  const scrollTo = (id) => scrollToSection(id);

  return (
    <section id="services" className="relative py-16 md:py-36 px-6 md:px-12 bg-card" style={{ scrollMarginTop: 80 }}>
      <div className="max-w-7xl mx-auto">
        <Reveal>
          <div className="max-w-2xl">
            <Eyebrow>{t("services.badge")}</Eyebrow>
            <h2 className="mt-6 font-serif text-4xl md:text-5xl text-foreground leading-tight">
              {t("services.title")}
            </h2>
            <p className="mt-5 text-muted-foreground font-sans leading-relaxed">{t("services.subtitle")}</p>
          </div>
        </Reveal>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((s, i) => (
            <Reveal key={s.id} delay={(i % 3) * 0.08}>
              <button
                data-testid={`service-card-${s.id}`}
                onClick={() => scrollTo("portfolio")}
                className="group relative w-full text-left overflow-hidden bg-background border border-border hover:border-gold/50 transition-all duration-500"
              >
                <div className="relative h-60 overflow-hidden">
                  <img
                    src={s.img}
                    alt={sTitle(s.id)}
                    loading="lazy"
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-[1200ms] ease-out"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent" />
                </div>
                <div className="p-7">
                  <div className="flex items-start justify-between gap-3">
                    <h3 className="font-serif text-2xl text-gold">{sTitle(s.id)}</h3>
                    <ArrowUpRight
                      size={20}
                      className="text-muted-foreground/60 group-hover:text-gold group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-300 shrink-0 mt-1"
                    />
                  </div>
                  <p className="mt-3 text-sm text-muted-foreground font-sans leading-relaxed">
                    {sDesc(s.id)}
                  </p>
                </div>
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
